import React, { Component } from 'react';
import { 
   Container, 
   Paper, 
   Grid, 
   Breadcrumbs, 
   Link, Typography, 
   TextField, 
   Button, 
   TableRow, 
   TableCell, Table, TableContainer, TableHead, TableBody, IconButton} from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import ImageUploader from 'react-images-upload';
import uuid from 'uuid';
import { openMensajePantalla } from '../../session/actions/snackbarAction'
import { consumerFirebase } from '../../config';
import EditIcon from '@material-ui/icons/Edit';


const style = {
   container: {
      paddingLeft: "5em"
   },
   paper: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "20px",
   },
   link: {
      display: "flex"
   },
   homeIcon: {
      width: 20,
      height: 20,
      marginRight: "4px"
   },
   submit: {
      marginTop: "3em",
      marginBottom: "2em"
   },
   image: {
      height: "100px",
   },
   paperForm: {
      padding: "2em",
      marginTop: "2em",
      paddingBottom: "4em"
   },
   selectBrand: {
      width: '100%'
   },
   paperTitle:{
      marginBottom: '2em'
   },
   tablecontainer:{
      marginTop: '3em'
   }
}

class SubCategory extends Component {

   state = {
      config:{
         name: '',
         description: '',
         link:'',
         images: ''
      },
      menu: {
         name: '',
         description: '',
         images: ''
      },
      files:[],
      company: [],
      configCompany: [],
      menuRestaurant: []
   };

   dataIntoState = e => {
      let config_ = Object.assign({}, this.state.config);
      config_[e.target.name] = e.target.value;
      this.setState({
         config: config_
      })
   }

   handleChange = (e) => {
      let menu_ = Object.assign({}, this.state.menu);
      menu_[e.target.id] = e.target.value;
      this.setState({
        menu : menu_
      })
   }

   async componentDidMount() {
      const {id} = this.props.match.params 

      const companyCollection = this.props.firebase.db.collection("Categories");
      const companyDB = await companyCollection.doc(id).get();

      
      let objectQuery = this.props.firebase.db.collection("Categories").doc(id).collection("SubCategory")
      let objectQueryMenu = this.props.firebase.db.collection("Categories").doc(id).collection("SubCategory")

      const snapshot = await objectQuery.get();
      const snapshotMenu= await objectQueryMenu.get();

      const arrayConfigCompany = snapshot.docs.map(doc => {
         let data = doc.data();
         let id = doc.id;
         return { id, ...data};
      })
     
      const arrayUsersCompany = snapshotMenu.docs.map(doc => {
         let dataUser = doc.data();
         let idUser = doc.id;
         return { idUser, ...dataUser};
      })

      this.setState({
         company : companyDB.data(),
         configCompany: arrayConfigCompany,
         menuRestaurant: arrayUsersCompany
      })
   }


   uploadImages = documents => {
      Object.keys(documents).forEach(function(key) {
         documents[key].urlTemp = URL.createObjectURL(documents[key])
      })

      this.setState({
         files : this.state.files.concat(documents)
      })
   }



   saveProduct = () => {
      const { files, config, menu} = this.state;
      const { id } = this.props.match.params;

      Object.keys(files).forEach(function(key){
         let dinamicValue = Math.floor(new Date().getTime()/1000);
         let name = files[key].name;
         let extension = name.split(".").pop();
         files[key].alias = (name.split(".")[0] + "_" + dinamicValue + "." + extension).replace(/\s/g,"_").toLowerCase();
      })

      this.props.firebase.saveDocuments(files).then(arrayUrls => {
         config.images = arrayUrls;
        

         this.props.firebase.db
         .collection("Categories")
         .doc(id).collection("SubCategory")
         .add(config)
         .then(success => {
            this.props.history.push("/categories");
         })
         .catch(error => {
            openMensajePantalla({
               open: true,
               mensaje: error
            })
         })
      })

      
   }

   dropImage = nameImage => () => {
      this.setState({
         files: this.state.files.filter(file => {
            return file.name !== nameImage
         })
      })
   }

   editSubCategory = id => {
      this.props.history.push("subcategories/" + id);
   }

   render(){
      let imageKey = uuid.v4();

      return(
         <Container style={style.container} xs={6} md={6}>
            <Paper style={style.paper}>
               <Grid container spacing={3}>
                  <Grid item xs={12} md={8}>
                     <Breadcrumbs aria-label="breadcrumb">
                        <Link color="inherit" style={style.link} href="/categories">
                           <HomeIcon style={style.homeIcon}/>
                        </Link>
                       
                        <Typography color="textPrimary" >Sub Categorias</Typography>
                        
                     </Breadcrumbs>
                  </Grid>
               </Grid>
            </Paper> 
            <Paper style={style.paperForm}>
               <Typography component="h1" variant="h6" style={style.paperTitle}>
                  Crear Sub Categoria
               </Typography>
            
               <Grid container spacing={2} md={12}>
                  <Grid item xs={12} sm={6}>
                     <Table>
                        <TableBody>
                        
                           {
                              this.state.files.map((file, i) => (
                                 <TableRow key={i}>
                                    <TableCell align="left">
                                       <img src={file.urlTemp} style={style.image}/>
                                    </TableCell>
                                    <TableCell>
                                       <Button
                                          variant="contained"
                                          color="secondary"
                                          size="small"
                                          onClick={this.dropImage(file.name)}
                                       >
                                          Eliminar
                                       </Button>
                                    </TableCell>
                                 </TableRow>
                              ))
                           }
                        </TableBody>
                     </Table>
                  </Grid>
               
                  <Grid item xs={12} md={12}>
                     <ImageUploader
                        withIcon={false}
                        key={imageKey}
                        singleImage={true}
                        buttonText="Seleccione una imágen"
                        onChange={this.uploadImages}
                        imgExtension={[".jpg", ".gif", ".png", ".jpeg", ".mp4"]}
                        maxFileSize={25242880}
                     />
                  </Grid>
                  <Grid item xs={12} md={6}>
                     <TextField
                        name="name"
                        label="Nombre"
                        fullWidth
                        onChange={this.dataIntoState}
                        value={this.state.config.nameCombo}
                     />
                  </Grid>

                  <Grid item xs={12} md={6}>
                     <TextField
                        name="link"
                        label="URL Video"
                        fullWidth
                        onChange={this.dataIntoState}
                        value={this.state.config.link}
                     />
                  </Grid>
                  <Grid item xs={12} md={12}>
                     <TextField
                        name="description"
                        label="Descripción"
                        fullWidth
                        onChange={this.dataIntoState}
                        value={this.state.config.descripcionCombo}
                     />
                  </Grid>


                  <Grid container justify="center">
                     <Grid item xs={12} md={12}>
                        <Button
                           type="button"
                           fullWidth
                           variant="contained"
                           size="large"
                           color="primary"
                           style={style.submit}
                           onClick={this.saveProduct}
                        >
                           Guardar
                        </Button>
                     </Grid>
                  </Grid>
               </Grid>
           
            </Paper>   
            

            <Paper style={style.paperForm} >
               
               <Grid container spacing={2} md={12} >
                 
                  <TableContainer style={style.tablecontainer} justify="center">
                     <Table style={style.table} justify="center" aria-label="simple table">
                        <TableHead style={style.head}>
                           <TableRow style={style.row}>
                              <TableCell align="center">Sub Categoria</TableCell>
                              <TableCell align="center">Descripción</TableCell>
                           </TableRow>
                        </TableHead>
                        <TableBody>
                        {this.state.menuRestaurant.map(info => (
                           <TableRow key={info.id}>
                              <TableCell align="center">{info.name}</TableCell> 
                              <TableCell align="center">{info.description}</TableCell> 
                              {/**<img src={info.images}/>**/}
                           </TableRow> 
                        ))}
                        </TableBody>
                     </Table>
                  </TableContainer>
               </Grid>
            </Paper>
            
         </Container>
      );
   }
}

export default consumerFirebase(SubCategory); 